(function () {
    "use strict";

    const NimbusCheckout = function () {
        this.isLoading = false;

        /* PERFORMANCE TRACKING */
        this.perf = {
            startCheckout() {
                try {
                    performance.mark("nimbus_checkout_start");
                } catch (e) {
                    console.error(e);
                }
            },
            endCheckout() {
                try {
                    performance.mark("nimbus_checkout_end");
                    performance.measure("nimbus_checkout", "nimbus_checkout_start", "nimbus_checkout_end");
                    const entry = performance.getEntriesByName("nimbus_checkout").pop();
                    console.log(
                        `⏱ Nimbus Checkout Load Time: ${entry.duration.toFixed(2)}ms`
                    );
                } catch (e) {
                    console.error(e);
                }
            }
        };

        this.machineId = localStorage.getItem("nimbus_machine_id") || crypto.randomUUID();
        localStorage.setItem("nimbus_machine_id", this.machineId);

        this.storeDetails = () => ({
            baseUrl: "https://checkoutui.nimbuspost.com/shopify",
            store_url: `https://${Shopify.shop}/`,
            client_id: "f27cfac0797c657961bb9ec52dc228c9",
            client_secret: "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",
            client_xkey: "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",
            merchant_id: 243555,
            store_id: "695b67d2be3ab638b3b41ca2"
        });

        /* INIT */
        this.init = () => {
            this.injectStyles();
            this.setupMessageListener();
            this.addCheckoutButtons();
            this.setupIframeListener();
        };

        /* STYLES */

        this.lockScroll = () => {
            const scrollY = window.scrollY;

            document.body.dataset.scrollY = scrollY;
            document.documentElement.style.overflow = "hidden";
            document.body.style.position = "fixed";
            document.body.style.top = `-${scrollY}px`;
            document.body.style.left = "0";
            document.body.style.right = "0";
            document.body.style.width = "100%";
        };

        this.injectStyles = () => {
            const style = document.createElement("style");
            style.textContent = `
                #np-checkout-button {transition:.3s ease;}
                #np-checkout-button:disabled {opacity:.7;cursor:not-allowed;}
                .np-loading-spinner{width:16px;height:16px;border:2px solid #fff;border-radius:50%;border-top-color:transparent;animation:np-spin 1s linear infinite;margin-right:8px;display:inline-block;}
                @keyframes np-spin{to{transform:rotate(360deg);}}
                .np-loading-overlay{position:fixed;inset:0;background:rgba(0,0,0,.5);display:flex;align-items:center;justify-content:center;z-index:99999;opacity:0;visibility:hidden;transition:.3s;}
                .np-loading-overlay.show{opacity:1;visibility:visible; display:flex !important;}
                .np-loading-content{background:#fff;padding:30px;border-radius:8px;}
                .np-loading-spinner-large{width:40px;height:40px;border:4px solid #f3f3f3;border-top:4px solid #007bff;border-radius:50%;animation:np-spin 1s linear infinite;margin:0 auto 15px;}
                .main{display:flex;align-items:center;justify-content:center;width:100%;}
                .payment-options{padding-left:15px;width:60px;}
                a[href="/checkout"] {display:none !important;}
            `;
            document.head.appendChild(style);
        };

        /* BUTTON REPLACEMENT */

        this.addCheckoutButtons = () => {
            const isProduct = location.pathname.includes("/products/");

            /* Our checkout button */
            const npBtn = document.createElement("button");
            npBtn.id = "np-checkout-button";
            npBtn.className = "btn btn-theme gradient-theme btn-cart-checkout w-100";
            npBtn.name = "checkout";
            npBtn.innerHTML = `
                    <div class="main">
                        <span>Place Order</span>
                        <img src="https://fastrr-boost-ui.pickrr.com/assets/images/boost_button/upi_options.svg" alt="Google Pay | Phone Pay | UPI" class="payment-options" />
                    </div>
                `;
            npBtn.addEventListener("click", (e) => this.handleCheckout(e));

            /* UNIVERSAL REPLACE FUNCTION */
            const replaceCheckoutBtn = () => {
                const shopifyBtn = document.querySelector('button[name="checkout"]');

                if (shopifyBtn && !document.querySelector("#np-checkout-button")) {
                    shopifyBtn.replaceWith(npBtn);
                    return true;
                }
                return false;
            };

            /* 1. Replace immediately (fastest) */
            replaceCheckoutBtn();

            /* 2. Replace in microtask */
            queueMicrotask(() => replaceCheckoutBtn());

            /* 3. Observe DOM changes */
            const observer = new MutationObserver(() => replaceCheckoutBtn());
            observer.observe(document.body, { childList: true, subtree: true });

            /* PRODUCT PAGE BUY NOW */

            if (isProduct) {
                const buyNowBtn = document.createElement("button");
                buyNowBtn.id = "np-buyBtn";
                buyNowBtn.className = "shopify-payment-button__button shopify-payment-button__button--unbranded";
                buyNowBtn.innerHTML = `
                    <div class="main">
                        <span>Buy Now</span>
                        <img src="https://fastrr-boost-ui.pickrr.com/assets/images/boost_button/upi_options.svg" alt="Google Pay | Phone Pay | UPI" class="payment-options" />
                    </div>
                `;
                buyNowBtn.addEventListener("click", (e) => this.buyNow(e));

                const replaceBuyNow = () => {
                    const shopifyBuyNow = document.querySelector(".shopify-payment-button__button--unbranded");
                    if (shopifyBuyNow && !document.querySelector("#np-buyBtn")) {
                        shopifyBuyNow.replaceWith(buyNowBtn);
                        return true;
                    }
                    return false;
                };

                replaceBuyNow();
                queueMicrotask(() => replaceBuyNow());

                const buyObserver = new MutationObserver(() => replaceBuyNow());
                buyObserver.observe(document.body, { childList: true, subtree: true });
            }
        };

        /* LOADING UI */

        this.showLoading = () => {
            this.isLoading = true;

            if (!document.querySelector("#np-loading-overlay")) {
                const overlay = document.createElement("div");
                overlay.id = "np-loading-overlay";
                overlay.className = "np-loading-overlay";
                overlay.innerHTML = `
                    <div class="np-loading-content">
                        <div class="np-loading-spinner-large"></div>
                        <p>Processing your order...</p>
                    </div>
                `;
                document.body.appendChild(overlay);
                requestAnimationFrame(() => overlay.classList.add("show"));
            }

            const btn = document.querySelector("#np-checkout-button");
            if (btn) {
                btn.disabled = true;
                btn.innerHTML = `<span class="np-loading-spinner"></span> Processing...`;
            }
        };

        this.hideLoading = () => {
            this.isLoading = false;

            const overlay = document.querySelector("#np-loading-overlay");
            if (overlay) {
                overlay.classList.remove("show");
                setTimeout(() => overlay.remove(), 300);
            }

            const btn = document.querySelector("#np-checkout-button");
            if (btn) {
                btn.disabled = false;
                btn.innerText = "Place Order";
            }
        };

        /* CART API (HIGH PRIORITY) */

        this.cartApi = async () => {
            const store = this.storeDetails();
            const baseUrl = store.baseUrl;

            const encode = (obj) =>
                btoa(unescape(encodeURIComponent(JSON.stringify(obj))));

            try {
                const cart = await fetch("/cart.js").then((r) => r.json());

                if (!cart.items.length) {
                    this.hideLoading();
                    alert("Your cart is empty.");
                    return;
                }

                const order = {
                    token: cart.token,
                    items_subtotal_price: cart.items_subtotal_price,
                    original_total_price: cart.original_total_price,
                    total_discount: cart.total_discount,
                    items: cart.items.map((i) => ({
                        final_line_price: i.final_line_price,
                        price: i.price,
                        quantity: i.quantity,
                        variant_id: i.variant_id,
                        product_id: i.product_id,
                        product_title: i.product_title,
                        image: i.image,
                        currency: i.currency,
                        final_price: i.final_price,
                        original_line_price: i.original_line_price,
                        discounts: i.discounts,
                        grams: i.grams
                    }))
                };

                const payload = {
                    userDeviceId: this.machineId,
                    cart_items: order,
                    stote_detail: store
                };

                const iframe = document.createElement("iframe");
                iframe.src = `${baseUrl}?order=${encode(payload)} `;
                iframe.style.cssText = `
                    position: fixed;
                    id: np-iframe;
                    inset: 0;
                    width: 100%;
                    height: 100%;
                    z-index: 999999;
                    border: none;
                `;

                this.lockScroll();

                iframe.onload = () => {
                    this.hideLoading();
                    this.perf.endCheckout();
                };
                iframe.onerror = () => {
                    this.hideLoading();
                    this.perf.endCheckout();
                    alert("Failed to load checkout.");
                };

                document.body.appendChild(iframe);
            } catch (err) {
                console.error("Cart API Error:", err);
                this.hideLoading();
                this.perf.endCheckout();
                alert("Order processing failed.");
            }
        };

        /* CHECKOUT CLICK */

        this.handleCheckout = (e) => {
            e.preventDefault();
            if (this.isLoading) return;

            this.lockScroll();
            this.perf.startCheckout();
            this.showLoading();
            this.cartApi();
            setTimeout(() => {
                let el = document.querySelector(".button.close-button.cart-drawer__close-button.button-unstyled");
                if (el) el.click();
            }, 50);
        };

        /* BUY NOW CLICK */

        this.buyNow = async (event) => {
            event.preventDefault();
            if (this.isLoading) return;
            
            this.lockScroll();
            this.perf.startCheckout();
            this.showLoading();
            
            const p = event?.view?.ShopifyAnalytics?.meta;
            // console.log(p)
            const selectedVariant = p?.product?.variants?.find(el => el?.id === Number(p?.selectedVariantId)) || p?.product?.variants?.[0];
            // console.log(selectedVariant)
            const quantity = document.querySelector("#Quantity").value || 1

            const fd = new FormData();
            fd.append("form_type", "product");
            fd.append("quantity", quantity);
            fd.append("color", selectedVariant?.public_title || "Default Color");
            fd.append("size", selectedVariant?.sku?.split("=")[2]?.trim() || "Default Size");
            fd.append("id", selectedVariant?.id);
            fd.append("product-id", p?.product?.id);

            await fetch("/cart/clear.js", { method: "POST" });
            await fetch("/cart/add.js", { method: "POST", body: fd });
            this.cartApi();
        };

        /* MESSAGE HANDLERS */

        this.setupMessageListener = () => {
            window.addEventListener("message", (event) => {
                if (event.data?.type === "gtag_event" && typeof gtag === "function") {
                    gtag("event", event.data.eventName, event.data.eventParams);
                }
                // else {
                //     console.log('GTAG SCRIPT NOT FOUND');
                // }
            });
        };

        this.setupIframeListener = () => {
            window.addEventListener("message", async (event) => {
                if (event.data === "close_and_refresh") {
                    this.lockScroll();
                    location.reload();
                }

                if (["continue_shipping", "continue_shipping_cod", "continue_shipping_prepaid"].includes(event.data)) {
                    this.lockScroll();
                    await fetch("/cart/clear.js", { method: "POST" });
                    if (event.data === "continue_shipping") location.reload();
                }
            });
        };
    };

    /* DOM READY */
    document.readyState === "loading"
        ? document.addEventListener("DOMContentLoaded", () => new NimbusCheckout().init())
        : new NimbusCheckout().init();
})();